/* iJewel3D Shopify integration loader (safe, non-destructive) */
(function () {
  // IMMEDIATELY inject CSS to hide loading screen before anything else loads
  (function hideLoadingScreenEarly() {
    const earlyStyle = document.createElement('style');
    earlyStyle.id = 'ijewel-hide-loading-early';
    earlyStyle.textContent = `
      #assetManagerLoadingScreen,
      [id="assetManagerLoadingScreen"],
      [id*="LoadingScreen"],
      [id*="loadingScreen"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
      }
    `;
    // Insert into head as early as possible
    if (document.head) {
      document.head.insertBefore(earlyStyle, document.head.firstChild);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.head.insertBefore(earlyStyle, document.head.firstChild);
      }, { once: true });
    }
    
    // INTERCEPT createElement to hide loading elements as soon as they're created
    const originalCreateElement = document.createElement.bind(document);
    document.createElement = function(tagName, options) {
      const element = originalCreateElement(tagName, options);
      // Check if this is a loading screen element when id is set
      const originalSetAttribute = element.setAttribute.bind(element);
      element.setAttribute = function(name, value) {
        originalSetAttribute(name, value);
        if (name === 'id' && (value === 'assetManagerLoadingScreen' || value.includes('LoadingScreen') || value.includes('loadingScreen'))) {
          this.style.display = 'none';
          this.style.visibility = 'hidden';
          this.style.opacity = '0';
          this.style.width = '0';
          this.style.height = '0';
          this.style.position = 'absolute';
          this.style.left = '-9999px';
        }
      };
      return element;
    };
    
    // Also set up observer to remove the element when it appears
    const hideLoadingElement = () => {
      const loadingScreen = document.getElementById('assetManagerLoadingScreen');
      if (loadingScreen) {
        loadingScreen.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;width:0!important;height:0!important;position:absolute!important;left:-9999px!important;top:-9999px!important;';
        // Try to remove from DOM
        try { loadingScreen.remove(); } catch(e) {}
      }
      // Also check for any element with LoadingScreen in id
      document.querySelectorAll('[id*="LoadingScreen"], [id*="loadingScreen"]').forEach(el => {
        el.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;';
        try { el.remove(); } catch(e) {}
      });
    };
    
    // Run immediately and also observe
    hideLoadingElement();
    
    const observer = new MutationObserver((mutations) => {
      hideLoadingElement();
    });
    
    // Start observing as soon as body exists
    const startObserving = () => {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
        // Also check periodically during initial load
        const interval = setInterval(() => {
          hideLoadingElement();
        }, 30);
        // Stop checking after 15 seconds
        setTimeout(() => clearInterval(interval), 15000);
      } else {
        setTimeout(startObserving, 10);
      }
    };
    startObserving();
  })();

  // Add lightweight logger
  const ijLog = (...args) => { try { console.log('[iJewel]', ...args); } catch (_) {} };
  const DEFAULT_SDK_URL = 'https://releases.ijewel3d.com/libs/mini-viewer/0.5.4/bundle.iife.js';

  // ---- Metal color handling (no SDK API available, so we operate on the live three.js scene) ----
  // Index 0 = White Gold, 1 = Yellow Gold, 2 = Rose Gold. PBR approximations used only when the
  // selected metal is NOT the one the model was authored in.
  const METAL_PBR = {
    0: { r: 0.85, g: 0.85, b: 0.86, metalness: 1.0, roughness: 0.18 }, // White Gold / Platinum
    1: { r: 0.94, g: 0.78, b: 0.38, metalness: 1.0, roughness: 0.22 }, // Yellow Gold
    2: { r: 0.91, g: 0.66, b: 0.55, metalness: 1.0, roughness: 0.22 }  // Rose Gold
  };
  // Selector index -> metal name (matches METAL_PBR order: 0 White, 1 Yellow, 2 Rose).
  const METAL_NAMES = ['White Gold', 'Yellow Gold', 'Rose Gold'];
  // Best-guess index of the metal the model was authored in. Selecting it restores the pristine
  // material instead of our approximation, so it never "breaks" after switching back.
  let _authoredMetalIndex = null;
  const _origMaterialProps = new WeakMap(); // original PBR props per material, for clean restore

  const isGemOrGlass = (m) =>
    (typeof m.transmission === 'number' && m.transmission > 0.1) ||
    (typeof m.ior === 'number' && m.ior > 1.6) ||
    /diamond|stone|gem|glass|sapphire|ruby|emerald|crystal/i.test(m.name || '');

  const isMetalMaterial = (m) => {
    const name = (m.name || '').toLowerCase();
    return name.includes('metal') || name.includes('gold') ||
           name.includes('platin') || name.includes('silver') ||
           (typeof m.metalness === 'number' && m.metalness >= 0.5);
  };

  // Collect metal materials in the scene and snapshot their original look once.
  function collectMetalMaterials(viewer) {
    const mats = [];
    if (!viewer || !viewer.scene || typeof viewer.scene.traverse !== 'function') return mats;
    viewer.scene.traverse((obj) => {
      if (!obj.material) return;
      (Array.isArray(obj.material) ? obj.material : [obj.material]).forEach((m) => {
        if (m && m.color && typeof m.color.setRGB === 'function' && !isGemOrGlass(m) && isMetalMaterial(m)) {
          mats.push(m);
          if (!_origMaterialProps.has(m)) {
            _origMaterialProps.set(m, {
              r: m.color.r, g: m.color.g, b: m.color.b,
              metalness: m.metalness, roughness: m.roughness,
              envMapIntensity: ('envMapIntensity' in m) ? m.envMapIntensity : undefined
            });
          }
        }
      });
    });
    return mats;
  }

  // Detect the model's authored metal (nearest swatch to the original color) WITHOUT modifying it,
  // and tell the selector to pre-highlight it so the UI matches the real product (#1).
  function snapshotAndDetectAuthored(viewer) {
    const mats = collectMetalMaterials(viewer);
    if (!mats.length || _authoredMetalIndex !== null) return;
    const o = _origMaterialProps.get(mats[0]);
    let best = 0, bestD = Infinity;
    Object.keys(METAL_PBR).forEach((k) => {
      const c = METAL_PBR[k];
      const d = (c.r - o.r) ** 2 + (c.g - o.g) ** 2 + (c.b - o.b) ** 2;
      if (d < bestD) { bestD = d; best = parseInt(k); }
    });
    _authoredMetalIndex = best;
    ijLog('snapshotAndDetectAuthored: authored metal index =', best);
    window.dispatchEvent(new CustomEvent('ijewel-authored-metal', { detail: { index: best } }));
  }

  // Apply the chosen metal to the scene. Restores the pristine material when the choice matches the
  // authored metal; otherwise applies a full PBR approximation (color + metalness/roughness/env).
  function applyMetalToScene(viewer, targetIndex) {
    const mats = collectMetalMaterials(viewer);
    if (!mats.length) { ijLog('applyMetalToScene: no metal materials found'); return 0; }
    if (_authoredMetalIndex === null) snapshotAndDetectAuthored(viewer);
    let applied = 0;
    mats.forEach((m) => {
      const orig = _origMaterialProps.get(m);
      if (targetIndex === _authoredMetalIndex && orig) {
        m.color.setRGB(orig.r, orig.g, orig.b);
        if (typeof orig.metalness === 'number') m.metalness = orig.metalness;
        if (typeof orig.roughness === 'number') m.roughness = orig.roughness;
        if (orig.envMapIntensity !== undefined) m.envMapIntensity = orig.envMapIntensity;
      } else {
        const t = METAL_PBR[targetIndex] || METAL_PBR[0];
        m.color.setRGB(t.r, t.g, t.b);
        if (typeof m.metalness === 'number') m.metalness = t.metalness;
        if (typeof m.roughness === 'number') m.roughness = t.roughness;
        if ('envMapIntensity' in m) m.envMapIntensity = Math.max((orig && orig.envMapIntensity) || m.envMapIntensity || 1, 1.2);
      }
      m.needsUpdate = true;
      applied++;
    });
    if (viewer.setDirty) viewer.setDirty();
    ijLog('applyMetalToScene: applied to', applied, 'materials (target', targetIndex, 'authored', _authoredMetalIndex, ')');
    return applied;
  }

  // Bring the 3D media into view so a color change is actually visible to the shopper (#3).
  function focusModelMedia() {
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    const cell = gallery.querySelector('.product-gallery__media[data-media-type="model"]');
    if (!cell) return;
    const rect = cell.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const mostlyVisible = rect.top < vh * 0.6 && rect.bottom > vh * 0.4;
    if (!mostlyVisible) {
      // Use "nearest" (not "center"/"start") so we scroll only enough to reveal the 3D media,
      // without pinning it to the top/center and dragging the next section into view (#2 parity).
      try { cell.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (_) {}
    }
  }

  // Open the 3D in the product's real metal (derived from the SKU), instead of the shared vjson's
  // default. Retries a few times because the configurator's materials may not be resolved at first.
  function applyInitialSkuMetal(viewer) {
    const idx = getSkuMetalIndex(getCurrentVariantSku());
    if (idx == null) { ijLog('applyInitialSkuMetal: no single-metal SKU code, leaving model as-is'); return; }
    ijLog('applyInitialSkuMetal: SKU metal index =', idx, '(', METAL_NAMES[idx], ')');
    let tries = 0;
    const attempt = () => {
      tries++;
      applyMetalColorToViewer(viewer, { name: METAL_NAMES[idx] });
      if (tries < 3) setTimeout(attempt, 900);
    };
    attempt();
  }

  // Merchant rule: the SKU's last dash-segment is a 3-digit code = metal-color (1st digit) + karat
  // (last 2 digits). Example "3000549138-PD096643-314" -> 314 -> color 3 (Rose), 14k.
  //   1 = White, 2 = Yellow, 3 = Rose            -> single metal: selectable + opens in that color
  //   4..7 = multi-color combos (2/3 tone)       -> color change disabled (selector hidden)
  function getSkuColorDigit(sku) {
    if (!sku || typeof sku !== 'string') return null;
    const seg = sku.trim().split('-').pop();
    if (!/^\d{3}$/.test(seg)) return null; // expect a 3-digit color+karat code
    return parseInt(seg.charAt(0), 10);
  }

  // Hide the metal-color selector for multi-color products (color digit 4 and up, i.e. code >= 400).
  function skuHidesColor(sku) {
    const d = getSkuColorDigit(sku);
    return d != null && d >= 4;
  }

  // Single-metal color digit -> our selector index (0 White, 1 Yellow, 2 Rose); null if not single.
  function getSkuMetalIndex(sku) {
    const d = getSkuColorDigit(sku);
    return d === 1 ? 0 : d === 2 ? 1 : d === 3 ? 2 : null;
  }

  // Resolve the currently-selected variant's SKU (updates as the shopper changes variants).
  function getCurrentVariantSku() {
    const map = window.iJewelVariantSkus || {};
    const input = document.querySelector(
      'product-form [name="id"], .product-form [name="id"], form[action*="/cart/add"] [name="id"], [name="id"]'
    );
    const id = input && input.value ? String(input.value) : null;
    if (id && map[id]) return map[id];
    return window.iJewelSelectedVariantSku || (id && map[id]) || null;
  }

  // Add a play/pause auto-rotate (360° spin) button overlaid on the 3D viewer, like zen-diamond.de
  // (which toggles viewer.scene.activeCamera.controls.autoRotate). Safe additive overlay: if the
  // control API isn't reachable on this build, the button simply won't spin (logged), nothing breaks.
  function createAutoRotateButton(holder, viewer) {
    if (!holder || holder.querySelector('.ijewel-autorotate-btn')) return;

    const setAutoRotate = (on) => {
      let ok = false;
      try {
        const cam = viewer && viewer.scene &&
          (viewer.scene.activeCamera || (viewer.scene.getActiveCamera && viewer.scene.getActiveCamera()));
        const controls = cam && cam.controls;
        if (controls && 'autoRotate' in controls) {
          controls.autoRotate = on;
          if (typeof controls.autoRotateSpeed === 'number') controls.autoRotateSpeed = 2.0;
          ok = true;
        }
      } catch (_) {}
      if (!ok) {
        try {
          const orp = viewer.getPlugin && viewer.getPlugin('ObjectRotationPlugin');
          if (orp) { orp.enabled = on; ok = true; }
        } catch (_) {}
      }
      try { viewer.setDirty && viewer.setDirty(); } catch (_) {}
      ijLog('autorotate:', on ? 'on' : 'off', 'applied =', ok);
      return ok;
    };

    const playIcon = '<svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 5v14l11-7z" fill="#222"/></svg>';
    const pauseIcon = '<svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 5h4v14H6zM14 5h4v14h-4z" fill="#222"/></svg>';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ijewel-autorotate-btn';
    btn.setAttribute('aria-label', 'Toggle 360° auto-rotate');
    btn.style.cssText = `
      position:absolute; right:14px; bottom:14px; z-index:120;
      width:40px; height:40px; border-radius:50%; padding:0;
      border:1px solid rgba(0,0,0,0.12); background:rgba(255,255,255,0.92);
      box-shadow:0 2px 8px rgba(0,0,0,0.15); cursor:pointer;
      display:flex; align-items:center; justify-content:center;
    `;
    btn.innerHTML = playIcon;

    let spinning = false;
    btn.addEventListener('click', () => {
      spinning = !spinning;
      setAutoRotate(spinning);
      btn.innerHTML = spinning ? pauseIcon : playIcon;
    });

    holder.appendChild(btn);
    ijLog('createAutoRotateButton: added');
  }

  // Remove the centered cube/prism badge that overlays the middle of the 3D model. It is NOT from
  // the iJewel SDK — it's Shopify's own model-viewer-ui "play poster" button
  // (button.shopify-model-viewer-ui__button--poster), which lives in a `.shopify-model-viewer-ui`
  // wrapper that is a SIBLING of our `.ijewel-viewer` holder inside <model-media>. Hiding the
  // <model-viewer> element alone doesn't remove it because the poster button sits in the
  // controls-overlay next to it. So once iJewel has mounted, we hide that whole Shopify wrapper for
  // this media cell (the iJewel viewer fully replaces it). CSS + a short observer, matching the
  // defensive style used elsewhere in this file.
  function hideInteractionPrompt(holder) {
    if (!holder) return;
    const mediaCell = holder.closest('model-media') || holder.parentElement;

    // 1) Scoped CSS: hide Shopify's model-viewer overlay only in cells that have an iJewel viewer,
    //    so products that fall back to the native model-viewer keep their poster/controls.
    if (!document.getElementById('ijewel-hide-poster-css')) {
      const style = document.createElement('style');
      style.id = 'ijewel-hide-poster-css';
      style.textContent = `
        model-media:has(.ijewel-viewer) .shopify-model-viewer-ui,
        model-media:has(.ijewel-viewer) .shopify-model-viewer-ui__controls-overlay,
        model-media:has(.ijewel-viewer) .shopify-model-viewer-ui__button--poster {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    // 2) Direct hide + observer fallback (covers browsers without :has and late-injected controls).
    const sweep = () => {
      if (!mediaCell) return;
      mediaCell.querySelectorAll(
        '.shopify-model-viewer-ui, .shopify-model-viewer-ui__controls-overlay, .shopify-model-viewer-ui__button--poster'
      ).forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        ijLog('hideInteractionPrompt: hid Shopify poster/overlay', el.className);
      });
    };
    sweep();
    [120, 400, 900, 1800, 3000].forEach((t) => setTimeout(sweep, t));
    if (mediaCell) {
      const obs = new MutationObserver(() => sweep());
      obs.observe(mediaCell, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 12000);
    }
  }

  // Hide the iJewel3D attribution watermark (bottom-left logo, the 320x150 SVG). NOTE: iJewel
  // renders it INSIDE the viewer's OPEN shadow root, so the page-level CSS used elsewhere in this
  // file can't reach it — we must inject a <style> into the shadow root itself. Their own
  // showLogo:false is ignored without a paid license (see the "License Required to remove
  // attribution" notice iJewel injects next to the SVG); this only hides it visually.
  const _ijewelWatermarkRoots = new WeakSet();
  function hideIJewelWatermark(holder) {
    if (!holder) return;
    const css = `
      svg[viewBox="0 0 320 150"],
      div:has(> svg[viewBox="0 0 320 150"]) {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        width: 0 !important;
        height: 0 !important;
        pointer-events: none !important;
      }
    `;
    const apply = () => {
      const nodes = [holder, ...holder.querySelectorAll('*')];
      nodes.forEach((node) => {
        const root = node.shadowRoot;
        if (!root) return;
        if (!_ijewelWatermarkRoots.has(root)) {
          _ijewelWatermarkRoots.add(root);
          const s = document.createElement('style');
          s.textContent = css;
          root.appendChild(s);
          ijLog('hideIJewelWatermark: injected style into shadow root');
        }
        root.querySelectorAll('svg[viewBox="0 0 320 150"]').forEach((svg) => {
          svg.style.setProperty('display', 'none', 'important');
          const wrap = svg.closest('div');
          if (wrap) wrap.style.setProperty('display', 'none', 'important');
          ijLog('hideIJewelWatermark: hid watermark svg');
        });
      });
    };
    apply();
    // Shadow-DOM mutations don't bubble to an outer observer, so we poll a few times to catch the
    // watermark once the viewer finishes rendering. The injected shadow <style> then keeps it hidden.
    [200, 600, 1200, 2500, 4000, 6000].forEach((t) => setTimeout(apply, t));
    const obs = new MutationObserver(() => apply());
    obs.observe(holder, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 15000);
  }

  const onDomReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  function loadScriptOnce(url, id) {
    return new Promise((resolve, reject) => {
      if (!url) return reject(new Error('No URL provided'));
      if (id && document.getElementById(id)) return resolve();
      const s = document.createElement('script');
      if (id) s.id = id;
      s.src = url;
      s.async = true;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = (e) => reject(e);
      document.head.appendChild(s);
    });
  }

  function getProductIdFromJSON() {
    const node = document.querySelector('script[id^="ProductJSON-"]');
    if (!node) return null;
    const m = node.id.match(/ProductJSON-(\d+)/);
    return m ? m[1] : null;
  }

  function getProductModels(productId) {
    const el = document.getElementById(`ProductJSON-${productId}`);
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch (e) { return []; }
  }

  function getModelSrcFromJson(model) {
    if (!model) return null;
    // Shopify model media JSON often has sources with glb
    if (Array.isArray(model.sources)) {
      const glb = model.sources.find(s => /\.glb($|\?)/i.test(s.url || s.src || ''));
      return glb?.url || glb?.src || null;
    }
    return model?.src || null;
  }

  function findModelMediaContainers() {
    return Array.from(document.querySelectorAll('model-media'));
  }

  function findContainerForMediaId(containers, mediaId) {
    // Try direct data-media-id on model-media (unlikely), else use closest wrapper div
    for (const c of containers) {
      const wrap = c.closest('[data-media-id]');
      if (wrap && String(wrap.getAttribute('data-media-id')) === String(mediaId)) return c;
    }
    return containers[0] || null;
  }

  function ensureHolder(container) {
    // Ensure container can hold absolutely positioned child
    const computed = window.getComputedStyle(container);
    if (computed.position === 'static') container.style.position = 'relative';

    const holder = container.querySelector('.ijewel-viewer') || document.createElement('div');
    holder.className = 'ijewel-viewer';
    holder.style.width = '100%';
    holder.style.height = '100%';
    holder.style.position = 'absolute';
    holder.style.inset = '0';
    holder.style.border = '0';
    holder.style.display = 'block';
    if (!holder.parentElement) container.appendChild(holder);
    return holder;
  }

  function buildIframe(src) {
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.allow = 'autoplay; fullscreen; xr-spatial-tracking; web-share';
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('mozallowfullscreen', 'true');
    iframe.setAttribute('webkitallowfullscreen', 'true');
    iframe.setAttribute('xr-spatial-tracking', '');
    iframe.setAttribute('execution-while-out-of-viewport', '');
    iframe.setAttribute('execution-while-not-rendered', '');
    iframe.setAttribute('web-share', '');
    iframe.style.border = '0';
    iframe.style.display = 'block';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    return iframe;
  }

  function getIJewelApi() {
    const candidates = [
      ['ijewelViewer', window.ijewelViewer],
      ['iJewelViewer', window.iJewelViewer],
      ['IJewelViewer', window.IJewelViewer],
      ['iJewel.viewer', window.iJewel?.viewer],
      ['IJewelMiniViewer', window.IJewelMiniViewer],
      ['iJewelMiniViewer', window.iJewelMiniViewer],
      ['MiniViewer', window.MiniViewer],
      ['iJewel3D.viewer', window.iJewel3D?.viewer],
      ['IJewel3D', window.IJewel3D],
      ['ViewerApp', window.ViewerApp]
    ];
    for (const [name, api] of candidates) {
      if (api) return { name, api };
    }
    return { name: 'none', api: null };
  }

  async function ensureSdkAvailable(settings) {
    ijLog('ensureSdkAvailable: checking globals', {
      ijewelViewer: !!window.ijewelViewer,
      iJewelViewer: !!window.iJewelViewer,
      IJewelViewer: !!window.IJewelViewer,
      iJewel_viewer: !!(window.iJewel && window.iJewel.viewer),
      MiniViewer: !!window.MiniViewer,
      ViewerApp: !!window.ViewerApp
    });
    let sdkAvailable = !!(window.ijewelViewer || window.iJewelViewer || window.IJewelViewer || window.iJewel?.viewer || window.IJewelMiniViewer || window.iJewelMiniViewer || window.MiniViewer || window.iJewel3D?.viewer || window.IJewel3D || window.ViewerApp);
    if (sdkAvailable) { ijLog('ensureSdkAvailable: SDK already present'); return true; }
    let sdkUrl = settings?.sdk_url || settings?.sdkUrl || settings?.viewer?.url;
    if (!sdkUrl) {
      sdkUrl = DEFAULT_SDK_URL;
      ijLog('ensureSdkAvailable: no sdk_url provided, using default', sdkUrl);
    } else {
      ijLog('ensureSdkAvailable: loading SDK from', sdkUrl);
    }
    try {
      await loadScriptOnce(sdkUrl, 'ijewel-sdk');
      const winKeys = Object.keys(window).filter(k => /jewel|viewer|miniv|ijewel|webgi/i.test(k));
      ijLog('ensureSdkAvailable: window candidates after load', winKeys);
      sdkAvailable = !!(window.ijewelViewer || window.iJewelViewer || window.IJewelViewer || window.iJewel?.viewer || window.IJewelMiniViewer || window.iJewelMiniViewer || window.MiniViewer || window.iJewel3D?.viewer || window.IJewel3D || window.ViewerApp);
      ijLog('ensureSdkAvailable: load complete, available =', sdkAvailable);
    } catch (e) {
      console.warn('[iJewel] Failed to load SDK script:', e);
    }
    return sdkAvailable;
  }

  async function mountIJewelInto(container, model, settings) {
    if (!container) { ijLog('mount: no container for model', model?.id || model?.media_id); return false; }
    const modelViewer = container.querySelector('model-viewer');
    ijLog('mount: begin', { mediaId: model?.id || model?.media_id, hasModelViewer: !!modelViewer });

    // Deep clone settings to modify variations array
    const customizedSettings = JSON.parse(JSON.stringify(settings));
    
    // Debug: log the full settings structure
    ijLog('mount: settings structure', {
      hasPlugins: !!customizedSettings?.plugins,
      isPluginsArray: Array.isArray(customizedSettings?.plugins),
      pluginsType: typeof customizedSettings?.plugins,
      pluginsKeys: customizedSettings?.plugins ? Object.keys(customizedSettings.plugins) : null,
      settingsKeys: Object.keys(customizedSettings),
      hasResources: !!customizedSettings?.resources,
      hasMaterials: !!customizedSettings?.resources?.materials,
      materialsCount: customizedSettings?.resources?.materials ? Object.keys(customizedSettings.resources.materials).length : 0
    });
    
    // Filter plugins array - remove SwitchNodePlugin entirely and filter MaterialConfiguratorPlugin variations
    if (Array.isArray(customizedSettings?.plugins)) {
      ijLog('mount: plugins is array with length', customizedSettings.plugins.length);
      
      // First, REMOVE SwitchNodePlugin and LoadingScreenPlugin entirely from the array
      const originalLength = customizedSettings.plugins.length;
      customizedSettings.plugins = customizedSettings.plugins.filter(plugin => {
        if (plugin.type === 'SwitchNodePlugin') {
          ijLog('mount: ✂️ REMOVING SwitchNodePlugin from plugins array');
          return false; // Remove it
        }
        if (plugin.type === 'LoadingScreenPlugin') {
          ijLog('mount: ✂️ REMOVING LoadingScreenPlugin from plugins array');
          return false; // Remove it - this causes the loading screen
        }
        return true; // Keep other plugins
      });
      ijLog('mount: plugins array reduced from', originalLength, 'to', customizedSettings.plugins.length);
      
      // Now process remaining plugins
      customizedSettings.plugins.forEach((plugin, index) => {
        ijLog('mount: plugin', index, 'type:', plugin.type, 'has variations:', !!plugin.variations);
        
        if (plugin.type === 'MaterialConfiguratorPlugin' && Array.isArray(plugin.variations)) {
          const originalCount = plugin.variations.length;
          ijLog('mount: MaterialConfiguratorPlugin found with', originalCount, 'variations');
          
          // Log all variation titles
          plugin.variations.forEach(v => ijLog('mount: variation title:', v.title));
          
          // Keep only the FIRST variation with title containing "Metal" (case-insensitive)
          // Having only ONE variation means no tabs will be shown - just the color options
          const metalVariations = plugin.variations.filter(v => {
            const title = (v.title || '').toLowerCase();
            return title.includes('metal');
          });
          
          // Keep only the first Metal variation to avoid tabs
          if (metalVariations.length > 0) {
            const mv = metalVariations[0];
            // Don't force the shared vjson's pre-selected metal (selectedIndex 0 = White Gold) onto
            // every product — that's why non-white products (e.g. rose) opened WHITE. The metal is
            // NOT encoded in the SKU (model codes like PD/RG ≠ metal), so we can't derive it; instead
            // we leave the selection unset so the model's own authored material is what shows on load.
            if (mv && typeof mv === 'object') { try { delete mv.selectedIndex; } catch (_) {} }
            plugin.variations = [mv];
            ijLog('mount: ✅ keeping only first Metal variation (selectedIndex cleared):', mv.title);
          } else {
            plugin.variations = [];
            ijLog('mount: ⚠️ no Metal variations found');
          }
          
          // Log what was filtered out
          const filteredOut = originalCount - plugin.variations.length;
          ijLog('mount: ✂️ filtered out', filteredOut, 'variations, keeping', plugin.variations.length);
        }
      });
    } else if (customizedSettings?.plugins && typeof customizedSettings.plugins === 'object') {
      ijLog('mount: ⚠️ plugins is an object, not array - cannot filter');
    } else {
      ijLog('mount: ⚠️ no plugins found in settings');
    }
    
    ijLog('mount: customized settings applied');

    const embedSrc = customizedSettings?.embed_src || customizedSettings?.embedSrc || customizedSettings?.embedding?.src || null;
    ijLog('mount: embedSrc =', embedSrc);
    if (embedSrc) {
      const holder = ensureHolder(container);
      ijLog('mount: using iframe embed');
      const iframe = buildIframe(embedSrc);
      holder.appendChild(iframe);
      iframe.addEventListener('load', () => {
        ijLog('mount: iframe loaded, hiding default model-viewer');
        if (modelViewer) modelViewer.style.display = 'none';
      }, { once: true });
      return true;
    }

    const sdkOk = await ensureSdkAvailable(customizedSettings);
    if (!sdkOk) {
      ijLog('mount: SDK not available, keeping default model-viewer');
      return false;
    }

    const jsonSrc = getModelSrcFromJson(model);
    const domSrc = modelViewer?.getAttribute('src') || null;
    const src = jsonSrc || domSrc;
    ijLog('mount: resolved src', { jsonSrc, domSrc, src });
    if (!src) {
      console.warn('[iJewel] No GLB/GLTF source found for model. Keeping default model-viewer.');
      return false;
    }

    const holder = ensureHolder(container);
    if (!holder.id) {
      const mediaId = String(model?.id || model?.media_id || Math.random()).replace(/[^a-zA-Z0-9_-]/g, '');
      holder.id = `ijewel-viewer-${mediaId}`;
    }

    try {
      const { name: apiName, api } = getIJewelApi();
      let apiKeys = [];
      try { apiKeys = api ? Object.keys(api) : []; } catch (_) {}
      ijLog('mount: api detected', { apiName, keys: apiKeys, hasLoad: !!api?.load, hasCreate: !!api?.create, hasInit: !!api?.init, hasMount: !!api?.mount, hasRender: !!api?.render, hasOpen: !!api?.open, hasStart: !!api?.start, isFunction: typeof api === 'function' });

      let instance = null;
      // Known method-based initializers - pass customizedSettings instead of settings
      if (api && typeof api.load === 'function') {
        ijLog('mount: trying api.load({ container, src, settings })');
        instance = await api.load({ container: holder, src, settings: customizedSettings || {} });
      }
      if (!instance && api && typeof api.create === 'function') {
        ijLog('mount: trying api.create({ container, src, settings })');
        instance = await api.create({ container: holder, src, settings: customizedSettings || {} });
      }
      if (!instance && api && typeof api.init === 'function') {
        ijLog('mount: trying api.init({ container, src, settings })');
        instance = await api.init({ container: holder, src, settings: customizedSettings || {} });
      }
      if (!instance && api && typeof api.mount === 'function') {
        ijLog('mount: trying api.mount({ container, src, settings })');
        try { instance = await api.mount({ container: holder, src, settings: customizedSettings || {} }); } catch (e) { ijLog('mount: api.mount object form failed', e); }
        if (!instance) { try { instance = await api.mount(holder, customizedSettings || {}); } catch (e) { ijLog('mount: api.mount(holder, settings) failed', e); } }
      }
      if (!instance && api && typeof api.render === 'function') {
        ijLog('mount: trying api.render({ container, src, settings })');
        try { instance = await api.render({ container: holder, src, settings: customizedSettings || {} }); } catch (e) { ijLog('mount: api.render failed', e); }
      }
      if (!instance && api && typeof api.open === 'function') {
        ijLog('mount: trying api.open({ container, src, settings })');
        try { instance = await api.open({ container: holder, src, settings: customizedSettings || {} }); } catch (e) { ijLog('mount: api.open object form failed', e); }
        if (!instance) {
          try { instance = await api.open(holder, { src, settings: customizedSettings || {} }); } catch (e) { ijLog('mount: api.open(holder, opts) failed', e); }
        }
      }
      if (!instance && api && typeof api.start === 'function') {
        ijLog('mount: trying api.start({ container, src, settings })');
        try { instance = await api.start({ container: holder, src, settings: customizedSettings || {} }); } catch (e) { ijLog('mount: api.start failed', e); }
      }

      // Mini Viewer specific: new ijewelViewer.Viewer(container, project, options)
      // Project config includes modelUrl and plugins/variations
      // ViewerOptions is the 3rd param for UI settings
      if (!instance && apiName === 'ijewelViewer' && api && typeof api.Viewer === 'function') {
        ijLog('mount: trying new ijewelViewer.Viewer(holder, projectConfig, viewerOptions)');
        try {
          // The iJewel Mini Viewer expects plugins as an OBJECT with plugin type names as keys
          // but our vjson has plugins as an ARRAY. Need to transform it.
          // Also need to include resources at the root level for materials to be loaded.
          
          // Start with base settings from vjson
          const projectConfig = {
            modelUrl: src,
            version: customizedSettings.version,
            type: customizedSettings.type
          };
          
          // Copy scene/background settings
          if (customizedSettings.useLegacyLights !== undefined) {
            projectConfig.useLegacyLights = customizedSettings.useLegacyLights;
          }
          if (customizedSettings.background) {
            projectConfig.background = customizedSettings.background;
          }
          if (customizedSettings.backgroundIntensity !== undefined) {
            projectConfig.backgroundIntensity = customizedSettings.backgroundIntensity;
          }
          if (customizedSettings.scene) {
            projectConfig.scene = customizedSettings.scene;
          }
          if (customizedSettings.renderManager) {
            projectConfig.renderManager = customizedSettings.renderManager;
          }
          
          // CRITICAL: Copy resources to root level - this contains all material definitions
          if (customizedSettings.resources) {
            projectConfig.resources = customizedSettings.resources;
            ijLog('mount: copied resources with', 
              Object.keys(customizedSettings.resources.materials || {}).length, 'materials');
          }
          
          // Transform plugins array to object format expected by SDK
          // The SDK expects: plugins: { MaterialConfiguratorPlugin: {...}, SwitchNodePlugin: {...} }
          if (Array.isArray(customizedSettings.plugins)) {
            projectConfig.plugins = {};
            customizedSettings.plugins.forEach(plugin => {
              if (plugin.type) {
                // Copy the plugin config under its type name
                projectConfig.plugins[plugin.type] = {
                  ...plugin,
                  // Also include resources reference for material lookup
                  resources: customizedSettings.resources
                };
                ijLog('mount: added plugin', plugin.type, 'to projectConfig.plugins object');
              }
            });
          } else if (customizedSettings.plugins && typeof customizedSettings.plugins === 'object') {
            // Already in object format
            projectConfig.plugins = customizedSettings.plugins;
          }
          
          // Log what we're passing to verify vjson is included
          ijLog('mount: FULL projectConfig structure:', {
            hasModelUrl: !!projectConfig.modelUrl,
            hasPlugins: !!projectConfig.plugins,
            pluginKeys: projectConfig.plugins ? Object.keys(projectConfig.plugins) : [],
            hasResources: !!projectConfig.resources,
            hasMaterials: !!projectConfig.resources?.materials,
            materialsCount: projectConfig.resources?.materials ? Object.keys(projectConfig.resources.materials).length : 0,
            version: projectConfig.version,
            type: projectConfig.type
          });
          
          // Add loading configuration to minimize/hide the loading screen
          // This is passed at the project level per iJewel docs
          projectConfig.loading = {
            showFileNames: false,
            backgroundOpacity: 0,
            loadingTextHeader: '',
            background: 'transparent',
            textColor: 'transparent',
            logoImage: ''
          };
          
          // ViewerOptions for UI controls - HIDE the built-in configurator entirely
          // We'll build our own simple metal color selector
          const viewerOptions = {
            showConfigurator: false,   // HIDE the entire configurator UI (tabs/options)
            showSwitchNode: false,     // Hide switch node UI
            splitMaterialTabs: false,  // DON'T split into tabs
            showLogo: false,           // Hide iJewel logo/attribution (requires license)
            showCard: false,           // Hide floating card with model details
            hideQuality: true,
            showUiButtons: false,      // Hide all UI buttons (rotate, loop, fullscreen, share)
            hideNameNumbers: true,     // Hide number suffixes on option names
            showZoomButtons: false,    // Hide zoom buttons
            hideCameraViews: true,     // Hide camera views button
            hideRotateCamera: true,    // Hide rotate camera button
            hideGltfAnimations: true,  // Hide GLTF animations controls
            hideFitScene: true,        // Hide fit scene button
            hideFullScreen: true,      // Hide fullscreen button
            showShareButton: false,    // Hide share button
            disableInteractionPrompt: true,  // Disable hand prompt overlay
            showPosterInLoadingScreen: false, // Hide loading screen poster/progress
            showLoadingScreen: false,  // Disable loading screen entirely
            loadingScreen: false,      // Alternative property name
            hideLoadingScreen: true,   // Another possible option
            assetManager: {
              showLoadingScreen: false,
              hideLoadingScreen: true,
              loadingScreen: false
            }
          };
          
          ijLog('mount: creating viewer with projectConfig and viewerOptions');
          
          // Before creating the viewer, set up aggressive loading screen hiding
          // that targets elements by ID directly with inline styles
          const hideLoadingScreenAggressive = () => {
            const loadingScreen = document.getElementById('assetManagerLoadingScreen');
            if (loadingScreen) {
              loadingScreen.setAttribute('style', 'display:none!important;visibility:hidden!important;opacity:0!important;width:0!important;height:0!important;position:absolute!important;left:-9999px!important;');
              // Also try to remove it from DOM
              try { loadingScreen.remove(); } catch(e) {}
              ijLog('mount: aggressively hid/removed assetManagerLoadingScreen');
            }
            // Also hide any element inside holder with "loading" in id
            holder.querySelectorAll('[id*="loading"], [id*="Loading"]').forEach(el => {
              el.setAttribute('style', 'display:none!important;visibility:hidden!important;');
              try { el.remove(); } catch(e) {}
            });
          };
          
          // Run immediately and set up interval during load
          hideLoadingScreenAggressive();
          const loadingInterval = setInterval(hideLoadingScreenAggressive, 50);
          setTimeout(() => clearInterval(loadingInterval), 15000); // Stop after 15s
          
          // Also add inline style to holder to hide loading children
          const holderStyle = document.createElement('style');
          holderStyle.textContent = `
            #${holder.id} #assetManagerLoadingScreen,
            #${holder.id} [id*="LoadingScreen"],
            #${holder.id} [id*="loadingScreen"] {
              display: none !important;
              visibility: hidden !important;
              opacity: 0 !important;
            }
          `;
          holder.appendChild(holderStyle);
          
          instance = new api.Viewer(holder, projectConfig, viewerOptions);
          
          // Try to access and hide the AssetManager loading screen through the viewer
          // The AssetManager is part of the underlying WebGi engine
          const tryHideAssetManagerLoading = () => {
            try {
              // Access the viewer's internal components
              if (instance && instance.assetManager) {
                // Try to disable the loading screen on the asset manager
                if (instance.assetManager.showLoadingScreen !== undefined) {
                  instance.assetManager.showLoadingScreen = false;
                }
                if (instance.assetManager.loadingScreen) {
                  instance.assetManager.loadingScreen.style.display = 'none';
                }
                ijLog('mount: disabled assetManager loading screen via API');
              }
              
              // Also try through the scene/viewer app
              if (instance && instance.viewer) {
                const v = instance.viewer;
                if (v.assetManager) {
                  if (typeof v.assetManager.setLoadingScreenEnabled === 'function') {
                    v.assetManager.setLoadingScreenEnabled(false);
                    ijLog('mount: called setLoadingScreenEnabled(false)');
                  }
                }
              }
            } catch (e) {
              ijLog('mount: tryHideAssetManagerLoading error:', e.message);
            }
          };
          
          // Try immediately and after short delays
          tryHideAssetManagerLoading();
          setTimeout(tryHideAssetManagerLoading, 100);
          setTimeout(tryHideAssetManagerLoading, 500);
          
          // optional: log when ready
          const onReady = (ev) => {
            ijLog('ijewel-viewer-ready received');
            window.removeEventListener('ijewel-viewer-ready', onReady);
            
            // Store viewer reference globally for our custom color selector
            window.iJewelViewerInstance = ev.detail.viewer;
            
            // HIDE the loading screen now that viewer is ready
            // Try multiple approaches to find and hide it
            try {
              const viewer = ev.detail.viewer;
              
              // 1. Direct AssetManager access
              if (viewer.assetManager) {
                if (viewer.assetManager.loadingScreen) {
                  viewer.assetManager.loadingScreen.style.display = 'none';
                  viewer.assetManager.loadingScreen.remove();
                }
                if (typeof viewer.assetManager.setLoadingScreenEnabled === 'function') {
                  viewer.assetManager.setLoadingScreenEnabled(false);
                }
              }
              
              // 2. Get plugin manager and find asset manager
              if (typeof viewer.getPlugin === 'function') {
                const assetMgr = viewer.getPlugin('AssetManagerPlugin') || viewer.getPlugin('AssetManager');
                if (assetMgr && assetMgr.loadingScreen) {
                  assetMgr.loadingScreen.style.display = 'none';
                }
              }
              
              // 3. Force hide by DOM
              const loadingEl = document.getElementById('assetManagerLoadingScreen');
              if (loadingEl) {
                loadingEl.style.display = 'none';
                loadingEl.remove();
                ijLog('onReady: removed assetManagerLoadingScreen from DOM');
              }
              
              ijLog('onReady: loading screen hiding attempted');
            } catch (e) {
              ijLog('onReady: error hiding loading screen:', e.message);
            }
            
            // Build the single custom metal selector (in the product form). The floating in-viewer
            // selector is intentionally NOT created, so only one color control is shown (#3).
            // Detect the model's authored metal so the right swatch is pre-selected on load.
            setTimeout(() => {
              createProductFormMetalSelector(ev.detail.viewer);
              setupIJewelCustomizations(ev.detail.viewer);
              snapshotAndDetectAuthored(ev.detail.viewer);
              createAutoRotateButton(holder, ev.detail.viewer);
              hideInteractionPrompt(holder);
              hideIJewelWatermark(holder);
              applyInitialSkuMetal(ev.detail.viewer);
            }, 500);
          };
          window.addEventListener('ijewel-viewer-ready', onReady, { once: true });
        } catch (e) {
          ijLog('mount: ijewelViewer.Viewer constructor failed', e);
        }
      }

      // Function-style initializer with common shape permutations - use customizedSettings
      if (!instance && typeof api === 'function') {
        const targetId = holder.id ? `#${holder.id}` : holder;
        const attempts = [
          { note: 'fn({ container, src, settings })', args: [{ container: holder, src, settings: customizedSettings || {} }] },
          { note: 'fn(holder, { src, settings })', args: [holder, { src, settings: customizedSettings || {} }] },
          { note: 'fn({ target, modelUrl, config })', args: [{ target: holder, modelUrl: src, config: customizedSettings || {} }] },
          { note: 'fn({ target: #id, model, vjson })', args: [{ target: targetId, model: src, vjson: customizedSettings || {} }] },
          { note: 'fn({ target, url, settings })', args: [{ target: holder, url: src, settings: customizedSettings || {} }] }
        ];
        for (const att of attempts) {
          if (instance) break;
          try { ijLog('mount: trying', att.note); instance = await api(...att.args); } catch (e) { ijLog('mount:', att.note, 'failed', e); }
        }
      }

      ijLog('mount: init result', { created: !!instance });
      if (instance) {
        if (modelViewer) modelViewer.style.display = 'none';
        return true;
      }
    } catch (e) {
      console.error('[iJewel] Failed to initialize viewer, falling back to model-viewer.', e);
    }
    return false;
  }

  // Hide unwanted configurator tabs by injecting CSS and observing DOM
  function hideNonMetalTabs() {
    ijLog('hideNonMetalTabs: starting');
    
    // Function to scan and hide tabs - we want to hide the ENTIRE tab bar
    // but keep the color options panel visible
    const processTabElements = () => {
      let hiddenCount = 0;
      
      // Target the tab list container and hide it entirely
      // This hides "Metal", "switch_node" etc tab buttons
      const tabLists = document.querySelectorAll('[data-slot="tabList"], [role="tablist"]');
      tabLists.forEach(tabList => {
        if (!tabList.closest('.ijewel-viewer')) return;
        if (!tabList.hasAttribute('data-ijewel-hidden')) {
          tabList.setAttribute('data-ijewel-hidden', 'true');
          tabList.style.display = 'none';
          hiddenCount++;
          ijLog('hideNonMetalTabs: hiding entire tabList');
        }
      });
      
      // Also hide individual tab buttons by their data-slot="tab" attribute
      const tabButtons = document.querySelectorAll('[data-slot="tab"], [role="tab"]');
      tabButtons.forEach(tab => {
        if (!tab.closest('.ijewel-viewer')) return;
        if (!tab.hasAttribute('data-ijewel-hidden')) {
          tab.setAttribute('data-ijewel-hidden', 'true');
          tab.style.display = 'none';
          hiddenCount++;
          ijLog('hideNonMetalTabs: hiding tab button ->', tab.textContent?.trim());
        }
      });
      
      // Hide the tab container parent if found (the div with flex that contains tabList)
      const tabContainers = document.querySelectorAll('.ijewel-viewer [data-slot="base"]');
      tabContainers.forEach(container => {
        if (!container.hasAttribute('data-ijewel-hidden')) {
          container.setAttribute('data-ijewel-hidden', 'true');
          container.style.display = 'none';
          hiddenCount++;
          ijLog('hideNonMetalTabs: hiding tab container');
        }
      });
      
      return hiddenCount;
    };
    
    // Run immediately and then observe for changes
    let hiddenCount = processTabElements();
    ijLog('hideNonMetalTabs: initial pass hidden', hiddenCount, 'elements');
    
    // Set up MutationObserver to catch dynamically added tabs
    const observer = new MutationObserver((mutations) => {
      let needsProcess = false;
      mutations.forEach(m => {
        if (m.addedNodes.length > 0) needsProcess = true;
      });
      if (needsProcess) {
        const newHidden = processTabElements();
        if (newHidden > 0) ijLog('hideNonMetalTabs: observer hidden', newHidden, 'more elements');
      }
    });
    
    // Observe the viewer container
    const viewerContainer = document.querySelector('.ijewel-viewer');
    if (viewerContainer) {
      observer.observe(viewerContainer, { childList: true, subtree: true });
      ijLog('hideNonMetalTabs: observer attached to .ijewel-viewer');
    }
    
    // Also observe body in case viewer is recreated
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Run again after delays to catch late-loading UI
    setTimeout(processTabElements, 100);
    setTimeout(processTabElements, 300);
    setTimeout(processTabElements, 500);
    setTimeout(processTabElements, 1000);
    setTimeout(processTabElements, 2000);
    setTimeout(processTabElements, 3000);
    setTimeout(processTabElements, 5000);
    
    // Inject global CSS to hide tab elements with !important
    const style = document.createElement('style');
    style.id = 'ijewel-hide-tabs-css';
    style.textContent = `
      /* Hide the iJewel Asset Manager Loading Screen */
      #assetManagerLoadingScreen,
      [id="assetManagerLoadingScreen"],
      .ijewel-viewer #assetManagerLoadingScreen,
      div#assetManagerLoadingScreen,
      *[id*="assetManagerLoadingScreen"],
      *[id*="LoadingScreen"],
      *[id*="loadingScreen"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        width: 0 !important;
        height: 0 !important;
        overflow: hidden !important;
        position: absolute !important;
        left: -9999px !important;
        top: -9999px !important;
      }
      
      /* Hide any loading-related elements */
      .ijewel-viewer [class*="loading"],
      .ijewel-viewer [class*="Loading"],
      .ijewel-viewer [class*="progress"],
      .ijewel-viewer [class*="Progress"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
      
      /* Hide the tab bar completely but keep color options */
      .ijewel-viewer [data-slot="tabList"],
      .ijewel-viewer [role="tablist"],
      .ijewel-viewer [data-slot="base"]:has([data-slot="tabList"]),
      .ijewel-viewer [data-slot="tab"],
      .ijewel-viewer [role="tab"],
      .ijewel-viewer [data-ijewel-hidden="true"] {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        width: 0 !important;
        overflow: hidden !important;
        position: absolute !important;
        pointer-events: none !important;
        opacity: 0 !important;
      }
      
      /* Hide the right-side control panel (rotate, loop, fullscreen, share buttons) */
      .ijewel-viewer .custom-scroll,
      .ijewel-viewer div.custom-scroll,
      .ijewel-viewer div[class*="custom-scroll"],
      .ijewel-viewer div:has(> #rotate),
      .ijewel-viewer div:has(> #loop),
      .ijewel-viewer #rotate,
      .ijewel-viewer #loop {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
      
      /* Hide the iJewel attribution/watermark logo at bottom-left */
      .ijewel-viewer div[style*="z-index: 9999"],
      .ijewel-viewer div[style*="pointer-events: none"]:has(svg),
      .ijewel-viewer > div[style*="position: absolute"][style*="bottom: 0"],
      .ijewel-viewer > div[style*="left: 0px"][style*="bottom: 0px"],
      .ijewel-viewer svg[viewBox="0 0 320 150"],
      .ijewel-viewer div:has(> svg[viewBox="0 0 320 150"]) {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        height: 0 !important;
        width: 0 !important;
        overflow: hidden !important;
      }
    `;
    if (!document.getElementById('ijewel-hide-tabs-css')) {
      document.head.appendChild(style);
      ijLog('hideNonMetalTabs: CSS injected');
    }
    
    ijLog('hideNonMetalTabs: complete');
  }

  // Create a custom metal color selector UI
  function createCustomMetalColorSelector(container, viewer) {
    ijLog('createCustomMetalColorSelector: starting');
    
    // Metal color options - these match typical jewelry metals
    const metalColors = [
      { name: 'White Gold', color: '#E8E8E8', materialColor: '#dcdcdc' },
      { name: 'Yellow Gold', color: '#FFD700', materialColor: '#ebd57d' },
      { name: 'Rose Gold', color: '#E8B4B8', materialColor: '#ffc49f' }
    ];
    
    // Create the selector container
    const selectorDiv = document.createElement('div');
    selectorDiv.id = 'ijewel-metal-selector';
    selectorDiv.style.cssText = `
      position: absolute;
      bottom: 16px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 12px;
      padding: 10px 16px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 30px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.15);
      z-index: 100;
      align-items: center;
    `;
    
    // Add label
    const label = document.createElement('span');
    label.textContent = 'Metal:';
    label.style.cssText = `
      font-size: 13px;
      font-weight: 500;
      color: #333;
      margin-right: 4px;
    `;
    selectorDiv.appendChild(label);
    
    // Create color buttons
    metalColors.forEach((metal, index) => {
      const btn = document.createElement('button');
      btn.setAttribute('data-metal', metal.name);
      btn.setAttribute('data-color', metal.materialColor);
      btn.setAttribute('title', metal.name);
      btn.style.cssText = `
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 2px solid ${index === 0 ? '#333' : 'transparent'};
        background: ${metal.color};
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 1px 3px rgba(0,0,0,0.2);
      `;
      
      // Hover effect
      btn.addEventListener('mouseenter', () => {
        btn.style.transform = 'scale(1.1)';
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'scale(1)';
      });
      
      // Click handler
      btn.addEventListener('click', () => {
        ijLog('createCustomMetalColorSelector: clicked', metal.name);
        
        // Update visual selection
        selectorDiv.querySelectorAll('button').forEach(b => {
          b.style.border = '2px solid transparent';
        });
        btn.style.border = '2px solid #333';
        
        // Store selected color globally
        window.iJewelSelectedMetalColor = metal.name;
        
        // Dispatch event for cart integration and syncing with product form
        window.dispatchEvent(new CustomEvent('ijewel-color-changed', { 
          detail: { color: metal.name, hex: metal.materialColor, source: 'viewer' } 
        }));
        
        // Try to change the material in the viewer
        applyMetalColorToViewer(viewer, metal);
      });
      
      selectorDiv.appendChild(btn);
    });
    
    // Set default selection
    window.iJewelSelectedMetalColor = metalColors[0].name;
    
    // Add to container
    container.appendChild(selectorDiv);
    ijLog('createCustomMetalColorSelector: UI created');
  }

  // Create metal color selector in the product form (next to variants)
  function createProductFormMetalSelector(viewer) {
    ijLog('createProductFormMetalSelector: starting');
    
    // Check if we already added it
    if (document.getElementById('ijewel-product-metal-selector')) {
      ijLog('createProductFormMetalSelector: already exists');
      return;
    }
    
    // Find the variant picker block - this is the specific structure from Prestige theme
    const variantPickerBlock = document.querySelector('.block_variant_picker') ||
                               document.querySelector('[data-block-type="variant-picker"]') ||
                               document.querySelector('variant-picker');
    
    if (!variantPickerBlock) {
      ijLog('createProductFormMetalSelector: no variant picker block found');
      return;
    }
    
    ijLog('createProductFormMetalSelector: found variant picker block');
    
    // Find the fieldset containing "Carat Option"
    const fieldsets = variantPickerBlock.querySelectorAll('fieldset');
    let targetFieldset = null;
    
    fieldsets.forEach(fs => {
      const legend = fs.querySelector('legend');
      if (legend && legend.textContent.toLowerCase().includes('carat')) {
        targetFieldset = fs;
        ijLog('createProductFormMetalSelector: found Carat Option fieldset');
      }
    });
    
    // Fallback to last fieldset or the variant picker itself
    if (!targetFieldset) {
      targetFieldset = fieldsets[fieldsets.length - 1] || variantPickerBlock;
      ijLog('createProductFormMetalSelector: using fallback target');
    }
    
    // Metal color options
    const metalColors = [
      { name: 'White Gold', color: '#E8E8E8', borderColor: '#CCCCCC', materialColor: '#dcdcdc' },
      { name: 'Yellow Gold', color: '#FFD700', borderColor: '#DAA520', materialColor: '#ebd57d' },
      { name: 'Rose Gold', color: '#E8B4B8', borderColor: '#D4A5A5', materialColor: '#ffc49f' }
    ];
    
    // Create the container matching the theme's variant-picker structure
    const selectorFieldset = document.createElement('fieldset');
    selectorFieldset.id = 'ijewel-product-metal-selector';
    selectorFieldset.className = 'variant-picker__option v-stack gap-2';
    selectorFieldset.style.cssText = 'margin-top: 1rem;';
    
    // Create the option info header (matches theme structure)
    const optionInfo = document.createElement('div');
    optionInfo.className = 'variant-picker__option-info h-stack justify-between gap-2';
    optionInfo.innerHTML = `
      <div class="h-stack gap-1">
        <legend>Metal Color:</legend>
      </div>
    `;
    selectorFieldset.appendChild(optionInfo);
    
    // Create options container (matches theme structure)
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'variant-picker__option-values h-stack gap-2.5 wrap';
    
    // Create color buttons styled like theme's block-swatch
    metalColors.forEach((metal, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-metal', metal.name);
      btn.setAttribute('data-color', metal.materialColor);
      btn.className = 'block-swatch' + (index === 0 ? ' is-selected' : '');
      btn.style.cssText = `
        display: flex;
        align-items: center;
        gap: 8px;
        padding: calc(var(--input-padding-block, 8px) - 1px) 0.875rem;
        border: ${index === 0 ? '2px solid rgb(var(--text-color, 18, 18, 18))' : '1px solid rgb(var(--border-color, 200, 200, 200))'};
        border-radius: var(--input-border-radius, 4px);
        background: transparent;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: inherit;
        color: ${index === 0 ? 'rgb(var(--text-color, 18, 18, 18))' : 'rgb(var(--text-color, 18, 18, 18) / 0.65)'};
        min-width: 2.5rem;
        justify-content: center;
      `;
      
      // Color swatch circle
      const swatch = document.createElement('span');
      swatch.style.cssText = `
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: ${metal.color};
        border: 1px solid ${metal.borderColor};
        display: inline-block;
        flex-shrink: 0;
      `;
      btn.appendChild(swatch);
      
      // Label text
      const labelText = document.createElement('span');
      labelText.textContent = metal.name;
      btn.appendChild(labelText);
      
      // Hover effects
      btn.addEventListener('mouseenter', () => {
        if (!btn.classList.contains('is-selected')) {
          btn.style.borderColor = 'rgb(var(--text-color, 18, 18, 18) / 0.5)';
          btn.style.color = 'rgb(var(--text-color, 18, 18, 18))';
        }
      });
      btn.addEventListener('mouseleave', () => {
        if (!btn.classList.contains('is-selected')) {
          btn.style.borderColor = 'rgb(var(--border-color, 200, 200, 200))';
          btn.style.color = 'rgb(var(--text-color, 18, 18, 18) / 0.65)';
        }
      });
      
      // Click handler
      btn.addEventListener('click', () => {
        ijLog('createProductFormMetalSelector: clicked', metal.name);
        
        // Update button styles
        optionsContainer.querySelectorAll('button').forEach(b => {
          b.classList.remove('is-selected');
          b.style.border = '1px solid rgb(var(--border-color, 200, 200, 200))';
          b.style.color = 'rgb(var(--text-color, 18, 18, 18) / 0.65)';
        });
        btn.classList.add('is-selected');
        btn.style.border = '2px solid rgb(var(--text-color, 18, 18, 18))';
        btn.style.color = 'rgb(var(--text-color, 18, 18, 18))';
        
        // Update the 3D viewer, then bring the 3D media into view so the change is visible (#3).
        applyMetalColorToViewer(viewer, metal);
        focusModelMedia();

        // Store selected color globally
        window.iJewelSelectedMetalColor = metal.name;
        
        // Dispatch event for cart integration (with source to avoid loops)
        window.dispatchEvent(new CustomEvent('ijewel-color-changed', { 
          detail: { color: metal.name, hex: metal.materialColor, source: 'form' } 
        }));
      });
      
      optionsContainer.appendChild(btn);
    });
    
    selectorFieldset.appendChild(optionsContainer);
    
    // Insert after the target fieldset
    if (targetFieldset.nextSibling) {
      targetFieldset.parentNode.insertBefore(selectorFieldset, targetFieldset.nextSibling);
    } else {
      targetFieldset.parentNode.appendChild(selectorFieldset);
    }
    
    // Set up sync: when viewer selector changes, update product form selector
    window.addEventListener('ijewel-color-changed', (e) => {
      // Only update if the event came from the viewer, not from this form
      if (e.detail?.source === 'form') return;
      
      const colorName = e.detail?.color;
      if (colorName) {
        optionsContainer.querySelectorAll('button').forEach(b => {
          b.classList.remove('is-selected');
          b.style.border = '1px solid rgb(var(--border-color, 200, 200, 200))';
          b.style.color = 'rgb(var(--text-color, 18, 18, 18) / 0.65)';
          if (b.getAttribute('data-metal') === colorName) {
            b.classList.add('is-selected');
            b.style.border = '2px solid rgb(var(--text-color, 18, 18, 18))';
            b.style.color = 'rgb(var(--text-color, 18, 18, 18))';
          }
        });
      }
    });
    
    // When the model's authored metal is detected, pre-select that swatch instead of defaulting
    // to White Gold, so the selector matches the product's real metal on first load (#1).
    const selectButtonByIndex = (idx) => {
      const btns = optionsContainer.querySelectorAll('button');
      if (idx == null || !btns[idx]) return;
      btns.forEach((b) => {
        b.classList.remove('is-selected');
        b.style.border = '1px solid rgb(var(--border-color, 200, 200, 200))';
        b.style.color = 'rgb(var(--text-color, 18, 18, 18) / 0.65)';
      });
      btns[idx].classList.add('is-selected');
      btns[idx].style.border = '2px solid rgb(var(--text-color, 18, 18, 18))';
      btns[idx].style.color = 'rgb(var(--text-color, 18, 18, 18))';
      if (metalColors[idx]) window.iJewelSelectedMetalColor = metalColors[idx].name;
    };
    // Prefer the SKU's metal (authoritative); else the model's detected authored metal.
    const skuMetalIdx = getSkuMetalIndex(getCurrentVariantSku());
    if (skuMetalIdx != null) {
      selectButtonByIndex(skuMetalIdx);
    } else if (_authoredMetalIndex !== null) {
      selectButtonByIndex(_authoredMetalIndex);
    } else {
      window.addEventListener('ijewel-authored-metal', (e) => selectButtonByIndex(e.detail?.index), { once: true });
    }

    // Hide the whole metal-color area for variants whose SKU last segment is > 500 (merchant rule),
    // and re-evaluate whenever the shopper switches variant. When hidden, clear the selected color
    // so it isn't added to the cart as a line-item property.
    const updateMetalVisibility = () => {
      const sku = getCurrentVariantSku();
      const hide = skuHidesColor(sku);
      selectorFieldset.style.display = hide ? 'none' : '';
      if (hide) window.iJewelSelectedMetalColor = null;
      ijLog('createProductFormMetalSelector: visibility for sku', sku, '-> hidden =', hide);
    };
    updateMetalVisibility();
    document.addEventListener('change', () => setTimeout(updateMetalVisibility, 50), true);

    ijLog('createProductFormMetalSelector: UI created and inserted after Carat Option');
  }

  // Apply metal color change to the viewer
  async function applyMetalColorToViewer(viewer, metal) {
    ijLog('applyMetalColorToViewer: applying', metal.name);
    
    try {
      // Index 0 = White Gold, 1 = Yellow Gold, 2 = Rose Gold (matches the custom selector order).
      const colorIndexMap = { 'White Gold': 0, 'Yellow Gold': 1, 'Rose Gold': 2 };
      const targetIndex = colorIndexMap[metal.name] ?? 0;

      if (!viewer) { ijLog('applyMetalColorToViewer: no viewer'); return; }

      // PREFERRED PATH — drive the real MaterialConfiguratorPlugin exactly like the WebGi reference
      // implementation on zen-diamond.de:  configurator.applyVariation(variation, material.uuid).
      // This loads the GENUINE material (full PBR), so non-white metals look right and switching
      // back to the original never degrades it. Confirmed API from the .de page source.
      let configurator = null;
      if (typeof viewer.getPlugin === 'function') {
        configurator = viewer.getPlugin('MaterialConfiguratorPlugin');
      }
      if (!configurator && viewer.plugins && typeof viewer.plugins.find === 'function') {
        configurator = viewer.plugins.find(p =>
          p?.constructor?.name === 'MaterialConfiguratorPlugin' || p?.type === 'MaterialConfiguratorPlugin');
      }

      const variations = (configurator && configurator.variations) || [];
      const metalVar = variations.find(v =>
        v.title?.toLowerCase().includes('metal') &&
        !v.title?.toLowerCase().includes('metal 2') &&
        !v.title?.toLowerCase().includes('metal 3')
      ) || variations[0];

      if (configurator && typeof configurator.applyVariation === 'function' &&
          metalVar && Array.isArray(metalVar.materials) && metalVar.materials.length) {
        const mats = metalVar.materials;
        const target = METAL_PBR[targetIndex] || METAL_PBR[0];

        // Resolve which material is the requested metal. Prefer matching by the material's own
        // swatch color (robust to arbitrary ordering); fall back to positional index.
        let chosen = null, bestD = Infinity;
        mats.forEach((mm) => {
          const col = mm && (mm.color || mm[metalVar.preview]);
          if (col && typeof col.r === 'number') {
            const d = (col.r - target.r) ** 2 + (col.g - target.g) ** 2 + (col.b - target.b) ** 2;
            if (d < bestD) { bestD = d; chosen = mm; }
          }
        });
        if (!chosen) chosen = mats[targetIndex] || mats[0];
        const uuid = chosen && (chosen.uuid || chosen.material?.uuid);

        if (uuid) {
          try {
            await configurator.applyVariation(metalVar, uuid);
            if (viewer.setDirty) viewer.setDirty();
            ijLog('applyMetalColorToViewer: ✅ applyVariation', metalVar.title, '->', uuid);
            return;
          } catch (e) {
            ijLog('applyMetalColorToViewer: applyVariation failed, falling back to scene tint:', e.message);
          }
        } else {
          ijLog('applyMetalColorToViewer: could not resolve material uuid (materials unresolved?), falling back');
        }
      } else {
        ijLog('applyMetalColorToViewer: configurator.applyVariation unavailable, using scene fallback');
      }

      // FALLBACK — operate directly on scene materials (pristine restore for the authored metal,
      // PBR approximation otherwise). Only used if the real configurator API isn't reachable.
      applyMetalToScene(viewer, targetIndex);

    } catch (e) {
      ijLog('applyMetalColorToViewer: error', e);
    }
  }

  // Setup customizations: track color selection from viewer events
  function setupIJewelCustomizations(viewer) {
    try {
      ijLog('setupIJewelCustomizations: starting');
      
      // Map hex colors to friendly names
      const getColorNameFromHex = (hex) => {
        const colorNames = {
          'dcdcdc': 'White Gold',
          'ffffff': 'White Gold',
          'ffc49f': 'Rose Gold',
          'ffb6c1': 'Rose Gold',
          'ebd57d': 'Yellow Gold',
          'ffd700': 'Yellow Gold',
          'c0c0c0': 'White Gold',
          'e5e4e2': 'White Gold'
        };
        const cleanHex = hex.toLowerCase().replace('#', '').replace('%23', '').substring(0, 6);
        return colorNames[cleanHex] || `Custom Color (#${cleanHex})`;
      };

      // Listen for postMessage events from iframe (if viewer is in iframe)
      window.addEventListener('message', (event) => {
        try {
          const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          
          // Check for material/color change events
          if (data.type === 'material-change' || data.type === 'color-change' || data.event === 'materialChanged') {
            const colorValue = data.color || data.material || data.value;
            if (colorValue) {
              const colorName = getColorNameFromHex(colorValue);
              window.iJewelSelectedMetalColor = colorName;
              ijLog('setupIJewelCustomizations: color from postMessage ->', colorName);
              window.dispatchEvent(new CustomEvent('ijewel-color-changed', { detail: { color: colorName } }));
            }
          }
        } catch (e) {
          // Not a JSON message or not relevant
        }
      });

      // Try to access viewer API if available (for non-iframe viewers)
      if (viewer && typeof viewer.on === 'function') {
        // Listen for material change events
        viewer.on('materialChange', (data) => {
          const colorValue = data.color || data.material || data.value;
          if (colorValue) {
            const colorName = getColorNameFromHex(colorValue);
            window.iJewelSelectedMetalColor = colorName;
            ijLog('setupIJewelCustomizations: color from viewer API ->', colorName);
            window.dispatchEvent(new CustomEvent('ijewel-color-changed', { detail: { color: colorName } }));
          }
        });
      }

      // Fallback: Try DOM-based tracking (for non-iframe viewers)
      const trackColorSelection = () => {
        const selectedOption = document.querySelector('#selectedOption img, [id*="Option"].outline-primary img, [id*="Option"][aria-current="true"] img');
        if (selectedOption) {
          const svgUrl = selectedOption.getAttribute('src');
          const colorMatch = svgUrl?.match(/fill='%23([a-fA-F0-9]{6})'/) || svgUrl?.match(/fill='%23([a-fA-F0-9]{3})'/);
          if (colorMatch) {
            const colorName = getColorNameFromHex(colorMatch[1]);
            if (window.iJewelSelectedMetalColor !== colorName) {
              window.iJewelSelectedMetalColor = colorName;
              ijLog('setupIJewelCustomizations: color from DOM ->', colorName);
              window.dispatchEvent(new CustomEvent('ijewel-color-changed', { detail: { color: colorName } }));
            }
          }
        }
      };

      // Track DOM clicks (fallback for non-iframe)
      document.addEventListener('click', (e) => {
        const isColorOption = e.target.closest('.ijewel-viewer [id*="Option"]') || 
                             e.target.closest('.ijewel-viewer img[src*="circle"]');
        if (isColorOption) {
          setTimeout(trackColorSelection, 150);
          ijLog('setupIJewelCustomizations: color option clicked');
        }
      }, true);

      // Initial tracking attempts
      setTimeout(trackColorSelection, 500);
      setTimeout(trackColorSelection, 1500);

      ijLog('setupIJewelCustomizations: complete - listening for color changes');
    } catch (e) {
      console.error('[iJewel] setupIJewelCustomizations failed', e);
    }
  }

  // Resolve settings: accept object, string URL, or object with { url }
  async function resolveSettings(input) {
    try {
      if (!input) { ijLog('resolveSettings: no input'); return {}; }
      if (typeof input === 'string') {
        const maybeUrl = input.trim();
        ijLog('resolveSettings: string input', maybeUrl);
        if (/^https?:\/\//i.test(maybeUrl) || maybeUrl.startsWith('//')) {
          const url = maybeUrl.startsWith('//') ? (location.protocol + maybeUrl) : maybeUrl;
          ijLog('resolveSettings: fetching settings from URL', url);
          const res = await fetch(url, { credentials: 'omit' });
          const json = await res.json();
          ijLog('resolveSettings: fetched JSON keys', Object.keys(json || {}));
          return json || {};
        }
        // Not a URL; try parse JSON literal
        try {
          const parsed = JSON.parse(maybeUrl);
          ijLog('resolveSettings: parsed JSON string');
          return parsed || {};
        } catch (_) {
          ijLog('resolveSettings: string not URL/JSON, returning empty');
          return {};
        }
      }
      if (typeof input === 'object') {
        if (typeof input.url === 'string') {
          const url = input.url.startsWith('//') ? (location.protocol + input.url) : input.url;
          ijLog('resolveSettings: fetching settings from input.url', url);
          const res = await fetch(url, { credentials: 'omit' });
          const json = await res.json();
          ijLog('resolveSettings: fetched JSON keys', Object.keys(json || {}));
          return json || {};
        }
        ijLog('resolveSettings: object input keys', Object.keys(input || {}));
        return input || {};
      }
    } catch (e) {
      console.warn('[iJewel] resolveSettings failed', e);
    }
    return {};
  }

  // Fix (#2): the 3D/video cells collapsing/reflowing is solved by reserving their exact height in
  // CSS (product-gallery.liquid), so the click now lands on the right media. But the theme scrolls
  // the clicked media to the very TOP of the viewport (`scrollIntoView({block:"start"})`), and the
  // 3D/video are the LAST gallery items — so pinning them to the top scrolls the page past them and
  // reveals the next section. We override just the scroll ALIGNMENT to "nearest" for model/video
  // thumbnail clicks, so the page scrolls only enough to bring the media fully into view.
  function setupModelThumbScroll() {
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    document.addEventListener('click', (e) => {
      const thumb = e.target.closest('.product-gallery__thumbnail');
      if (!thumb) return;
      const type = thumb.getAttribute('data-media-type');
      if (type !== 'model' && type !== 'video' && type !== 'external_video') return;

      const cell = gallery.querySelector(`.product-gallery__media[data-media-id="${thumb.getAttribute('data-media-id')}"]`);
      if (!cell || Object.prototype.hasOwnProperty.call(cell, 'scrollIntoView')) return;

      // Our capture-phase listener runs before the theme's handler, so this override is in place
      // when the theme calls cell.scrollIntoView({block:"start", ...}). Force "nearest" instead.
      const native = Element.prototype.scrollIntoView;
      cell.scrollIntoView = function (opts) {
        const behavior = (opts && typeof opts === 'object' && opts.behavior) || 'smooth';
        return native.call(this, { block: 'nearest', inline: 'nearest', behavior });
      };
      setTimeout(() => { try { delete cell.scrollIntoView; } catch (_) {} }, 400);
    }, true);

    ijLog('setupModelThumbScroll: block:nearest override attached');
  }

  onDomReady(async function () {
    ijLog('DOM ready');
    setupModelThumbScroll();
    const productId = getProductIdFromJSON();
    ijLog('ProductJSON id', productId);
    if (!productId) return;
    const models = getProductModels(productId) || [];
    ijLog('Parsed models count', models.length, models);
    if (!models.length) return;

    const rawSettings = (window.iJewelSDKSettings !== undefined) ? window.iJewelSDKSettings : {};
    ijLog('Raw settings type', typeof rawSettings);
    const settings = await resolveSettings(rawSettings);
    ijLog('Resolved settings keys', Object.keys(settings || {}), settings);

    const containers = findModelMediaContainers();
    ijLog('Found model-media containers', containers.length);

    for (const m of models) {
      const id = String(m.id || m.media_id || '');
      const container = findContainerForMediaId(containers, id);
      ijLog('Processing media', { id, hasContainer: !!container });
      if (!container) continue;
      const ok = await mountIJewelInto(container, m, settings);
      ijLog('Mount result for media', { id, ok });
      if (!ok) {
        const mv = container.querySelector('model-viewer');
        if (mv) mv.style.removeProperty('display');
      }
    }
  });
})();
